export default __webpack_public_path__ + "static/GRID22-global-map-fr-ecda4151ab421f88a0d5e9804ebb35be.png";